import {Error, Badge, CircleClose} from '@wix/wix-ui-icons-common/on-stage';
import {NoOnlineOrdersMessageDataHooks} from './NoOnlineOrdersMessage';
import {ILocaleKeys} from '../../../locale-keys/LocaleKeys';

export interface MessageActionParams {
  mainCta?: {text: string; url: string};
  secondaryLink?: {text: string; onClick: () => void};
}

export interface MessageUiParams {
  title: string;
  body: string;
  Icon: typeof Badge;
  iconDataHook: NoOnlineOrdersMessageDataHooks;
  actionParams?: MessageActionParams;
}

export const getNoOnlineOrdersParams = ({
  cannotShip,
  hasNoPremium,
  isOwnerOrPreview,
  localeKeys,
  upgradeUrlWithModalReferral,
  shippingSettingsUrl,
  onDismissNoPremiumError,
}: {
  cannotShip: boolean;
  hasNoPremium: boolean;
  isOwnerOrPreview: boolean;
  localeKeys: ILocaleKeys;
  upgradeUrlWithModalReferral: string;
  shippingSettingsUrl: string;
  onDismissNoPremiumError: () => void;
}): MessageUiParams => {
  const isOwnerCannotShip = isOwnerOrPreview && cannotShip;
  const isOwnerNoPremium = isOwnerOrPreview && hasNoPremium;
  const isBuyerCannotShip = !isOwnerOrPreview && cannotShip;

  if (isOwnerCannotShip) {
    return {
      title: localeKeys.checkout.noShippingMerchant.merchantCheckoutUnavailable.title(),
      body: localeKeys.checkout.noShippingMerchant.merchantCheckoutUnavailable.body(),
      Icon: Error,
      iconDataHook: NoOnlineOrdersMessageDataHooks.AlertIcon,
      actionParams: {
        mainCta: {
          url: shippingSettingsUrl,
          text: localeKeys.checkout.noShippingMerchant.merchantCheckoutUnavailable.cta(),
        },
      },
    };
  }
  if (isOwnerNoPremium) {
    return {
      title: localeKeys.checkout.noPremiumMerchant.merchantCheckoutUnavailable.title(),
      body: localeKeys.checkout.noPremiumMerchant.merchantCheckoutUnavailable.body(),
      Icon: Badge,
      iconDataHook: NoOnlineOrdersMessageDataHooks.BadgeIcon,
      actionParams: {
        mainCta: {
          url: upgradeUrlWithModalReferral,
          text: localeKeys.checkout.noPremiumMerchant.merchantCheckoutUnavailable.cta.$value(),
        },
        secondaryLink: {
          text: localeKeys.checkout.noPremiumMerchant.merchantCheckoutUnavailable.cta.secondary(),
          onClick: onDismissNoPremiumError,
        },
      },
    };
  }
  if (isBuyerCannotShip) {
    return {
      title: localeKeys.checkout.noShippingMerchant.checkoutUnavailable.title(),
      body: localeKeys.checkout.noShippingMerchant.checkoutUnavailable.body(),
      Icon: CircleClose,
      iconDataHook: NoOnlineOrdersMessageDataHooks.CloseIcon,
    };
  }
  return {
    title: localeKeys.checkout.noPremiumMerchant.checkoutUnavailable.title(),
    body: localeKeys.checkout.noPremiumMerchant.checkoutUnavailable.body(),
    Icon: CircleClose,
    iconDataHook: NoOnlineOrdersMessageDataHooks.CloseIcon,
  };
};
